module.exports = __webpack_public_path__ + "img/Layout-Kieka-desktop.f17b54b5.png";